import { createAction as createActionLegacy, createPayloadAction } from 'helpers/actionsHelpers'
import { FloatingPane } from 'interfaces/floatingPanes'
import { PayloadAction, SimpleAction } from 'interfaces/action'
import { createAction } from 'helpers/actionHelpers/createAction'

export const KILL_ALL_FLOATING_PANES = 'KILL_ALL_FLOATING_PANES' as const
type KillAllFloatingPanes = SimpleAction<typeof KILL_ALL_FLOATING_PANES>
export const killAllFloatingPanesActionCreator = () =>
  createActionLegacy(KILL_ALL_FLOATING_PANES)

export const KILL_FLOATING_PANES = 'KILL_FLOATING_PANES' as const
type KillFloatingPane = ReturnType<typeof killFloatingPanesActionCreator>
export const killFloatingPanesActionCreator = (...types: FloatingPane['type'][]) =>
  createPayloadAction(KILL_FLOATING_PANES, { types })

export const MODIFY_FLOATING_PANE = 'MODIFY_FLOATING_PANE' as const
/**
 * @deprecated Use `new ModifyFloatingPaneAction(...)`
 */
export type ModifyFloatingPane = PayloadAction<typeof MODIFY_FLOATING_PANE, FloatingPane>
/**
 * @deprecated Use `new ModifyFloatingPaneAction(...)`
 */
export const modifyFloatingPaneActionCreator = <TPane extends FloatingPane>(type: TPane['type'], payload: Partial<TPane>): ModifyFloatingPane =>
  createPayloadAction(MODIFY_FLOATING_PANE, {
    type,
    ...payload,
  }) as ModifyFloatingPane

export class ModifyFloatingPaneAction extends createAction<typeof MODIFY_FLOATING_PANE, FloatingPane>(MODIFY_FLOATING_PANE) {}

export const OPEN_SUBSCRIPTION_PANE = 'OPEN_SUBSCRIPTION_PANE'
type OpenSubscriptionDefault = SimpleAction<typeof OPEN_SUBSCRIPTION_PANE>
export function openSubscriptionPageActionCreator (): OpenSubscriptionDefault {
  return createActionLegacy(OPEN_SUBSCRIPTION_PANE)
}

export type FloatingPaneAction =
  | KillAllFloatingPanes
  | KillFloatingPane
  | ModifyFloatingPane
  | OpenSubscriptionDefault
  | ModifyFloatingPaneAction

export default FloatingPaneAction
